import * as _ from 'lodash';

import React, {Component} from 'react';

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import FdlOutlinedInput from "../../utils/FdlOutlinedInput/FdlOutlinedInput";
import {isFormValid} from "../../utils/helpers";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Divider from "@material-ui/core/Divider";


class PersonInfoModal extends Component {

  constructor(){
    super();

    this.state = {
      name: "",
      email:  "",
      errors: {
        name: true,
        email: true
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // update name & email when modal opens & closes
    if (nextProps.open && !this.props.open) {
      this.setState({
        name: nextProps.name ? nextProps.name : "",
        email: nextProps.email ? nextProps.email : "",
        cachedEmail: nextProps.email ? nextProps.email : "",
        errors: {
          name: !!!nextProps.name,
          email: !!!nextProps.email
        }
      });
    }
  }

  updateErrors(name, hasError) {
    const errors = _.cloneDeep(this.state.errors);
    errors[name] = hasError;

    this.setState({
      errors: errors
    });
  }

  savePerson() {
    this.props.save(this.state.name, this.state.email);
    this.props.toggleModal();
  }

  render() {
    return (
      <Dialog open={this.props.open}>
        <div className="person-info-container">
          <div className="flex items-center justify-between w-full sm:mb-2">
            <p className="text-2xl font-bold">{ this.props.title }</p>
            <FontAwesomeIcon icon="times" size="lg" className="text-grey cursor-pointer" onClick={this.props.toggleModal}/>
          </div>
          <Divider/>
          <div className="person-info-field mt-10">
            <FdlOutlinedInput value={this.state.name}
                              label={"Name"}
                              autoFocus
                              updateErrors={this.updateErrors.bind(this, "name")}
                              validators={["required"]}
                              onChange={(value) => this.setState({name: value})} />
          </div>
          <div className="person-info-field mt-10 mb-5">
            <FdlOutlinedInput value={this.state.email}
                              label={"Email"}
                              updateErrors={this.updateErrors.bind(this, "email")}
                              validators={["email", "required", "unique"]}
                              options={{userType: this.props.userType,
                                ownerEmail: this.props.ownerEmail,
                                keyholders: this.props.keyholders,
                                guardians: this.props.guardians,
                                cachedValue: this.state.cachedEmail}}
                              onChange={(value) => this.setState({email: value})} />
          </div>

          <div className="flex items-center justify-end">
            <Button onClick={this.props.toggleModal}>
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              disabled={!isFormValid(this.state.errors)}
              onClick={this.savePerson.bind(this)}
            >
              Save
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default PersonInfoModal;
